<template>
  <li
    v-if="canViewHorizontalNavMenuHeaderGroup(item)"
    class="dropdown nav-item"
    :class="{
      'sidebar-group-active active open': isActive,
      'show': isOpen,
    }"
    @mouseenter="() => updateGroupOpen(true)"
    @mouseleave="() => updateGroupOpen(false)"
  >
    <b-link class="nav-link dropdown-toggle d-flex align-items-center">
      <feather-icon
        size="14"
        :icon="item.icon"
      />
      <span>{{ t(item.header) }}</span>
    </b-link>
    <ul class="dropdown-menu">
      <component
        :is="resolveHorizontalNavMenuItemComponent(child)"
        v-for="child in item.children"
        :key="child.title"
        v-if="handleShowMenu(child.header || child.title, profileData.role)"
        :item="child"
      />
    </ul>
  </li>
</template>

<script>
import { mapGetters } from 'vuex'
import { BLink } from 'bootstrap-vue'
import { resolveHorizontalNavMenuItemComponent } from '@core/layouts/utils'
import { useUtils as useAclUtils } from '@core/libs/acl'
import { useUtils as useI18nUtils } from '@core/libs/i18n'
import useHorizontalNavMenuHeaderGroup from './useHorizontalNavMenuHeaderGroup'
import mixinHorizontalNavMenuHeaderGroup from './mixinHorizontalNavMenuHeaderGroup'
import MenuReportPermission, { restrictedReportPermission } from '@/common/permission/menu/report'

import HorizontalNavMenuGroup from '../horizontal-nav-menu-group/HorizontalNavMenuGroup.vue'
import HorizontalNavMenuLink from '../horizontal-nav-menu-link/HorizontalNavMenuLink.vue'

export default {
  components: {
    BLink,
    HorizontalNavMenuGroup,
    HorizontalNavMenuLink,
  },
  mixins: [mixinHorizontalNavMenuHeaderGroup],
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      profileData: 'User/user',
    })
  },
  data () {
    return {
      menuReportPermission: MenuReportPermission,
      restrictedReportPermission: restrictedReportPermission,
      handleHeader: [
        'Report',
        'Ticket Detail Report (New)',
        'Ticket Summary By Agent', 
        'Ticket Summary By Channel',
        'Ticket Summary By Case Type',
        'Detail Report'
      ],
      restrictedReportHeader: [
        'Categories',
        'Complain Report'
      ]
    }
  },
  methods: {
    handleShowMenu(header, role) {
      if (!header || !role) {
        return true // แสดงเมนูถ้าไม่มีข้อมูล
      }
      
      // ตรวจสอบ Categories Report และ Complain Report ก่อน (Super Admin เท่านั้น)
      if(this.restrictedReportHeader.includes(header) && !this.restrictedReportPermission.includes(role)) {
        return false
      }
      
      // ตรวจสอบ Report ทั่วไป
      if(this.handleHeader.includes(header) && !this.menuReportPermission.includes(role)) {
        return false
      }
      
      return true
    }
  },
  setup(props) {
    const {
      isActive,
      updateIsActive,
      isOpen,
      updateGroupOpen,
    } = useHorizontalNavMenuHeaderGroup(props.item)

    const { t } = useI18nUtils()
    const { canViewHorizontalNavMenuHeaderGroup } = useAclUtils()

    return {
      isOpen,
      isActive,
      updateGroupOpen,
      updateIsActive,
      resolveHorizontalNavMenuItemComponent,

      // ACL
      canViewHorizontalNavMenuHeaderGroup,

      // i18n
      t,
    }
  },
}
</script>
